import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ChatspotIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Chatspot",
    children: /*#__PURE__*/_jsx("path", {
      d: "M27.52 17.93c-.53 0-1 .3-1.25.73H25.1V2c-1.24.92-2.45 1.74-3.64 2.47v7.61h-.96V5.04c-1.36.79-2.7 1.48-4.04 2.09v4.95h-.96V7.55c-1.34.58-2.69 1.08-4.04 1.55v2.98h-.96V9.41c-.56.18-1.12.36-1.69.53-1.28.39-1.95 1.61-1.95 2.9v5.81H5.69a1.425 1.425 0 0 0-2.67.69c0 .78.64 1.42 1.42 1.42.54 0 1-.3 1.25-.73h1.18v.85c0 5.01 4.1 9.12 9.12 9.12 2.51 0 4.79-1.02 6.43-2.68a9.1 9.1 0 0 0 2.68-6.43v-.85h1.17a1.425 1.425 0 0 0 2.67-.69c0-.78-.64-1.42-1.42-1.42M14.36 28.21c-3.55-.66-5.69-3.5-5.75-6.28l-.11-5.1c-.02-.92.45-1.21 1.3-1.21h4.47c.9 0 1.26.4 1.26 1.18v6h-3.3c.14 1.58 1.49 2.43 3.3 2.91v1.67c-.02.65-.2 1.02-1.18.84Zm9.06-6.28c-.06 2.78-2.19 5.62-5.75 6.28-.98.18-1.17-.19-1.19-.84V25.7c1.82-.47 3.16-1.32 3.3-2.91h-3.3v-6c0-.78.36-1.18 1.26-1.18h4.47c.85 0 1.32.29 1.29 1.21l-.11 5.1h.02Zm-3.41-4.67c.74 0 1.34.56 1.34 1.25s-.6 1.25-1.34 1.25-1.34-.56-1.34-1.25.6-1.25 1.34-1.25m-7.99 0c.74 0 1.34.56 1.34 1.25s-.6 1.25-1.34 1.25-1.34-.56-1.34-1.25.6-1.25 1.34-1.25"
    })
  }));
};
ChatspotIcon.displayName = 'ChatspotIcon';